// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2dO3L","right":"Footer_right__V3gL0","buttons":"Footer_buttons__1kh-5"};